export default __webpack_public_path__ + "static/media/what_is_right.334306d2.svg";